

export const TopDeal=[
    'https://www.jiomart.com/images/cms/aw_rbslider/slides/1674756979_MonthEndDeals_1680x320.jpg',
    'https://www.jiomart.com/images/cms/aw_rbslider/slides/1674755921_Redmi_Smartphones_Desktop.jpg',
    'https://www.jiomart.com/images/cms/aw_rbslider/slides/1674756604_Laptop-Carnival-JioMart--Carousel-Banner-13_09_2022_1680x320.jpg',
    'https://www.jiomart.com/images/cms/aw_rbslider/slides/1675107852_1675014323_1674841079_1674797556_1674794009_HPMC_-1_1680x320_copy_32.jpg',

]